// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"4c4f9a01","141":"2001a8f4","260":"e9cc471a","425":"fe222186","453":"71c876a1","549":"9d8bd7a9","567":"1b64a695","657":"ced169d7","756":"e322e10d","943":"5afb217a"}[chunkId] + ".chunk.js";
};